<template>
  <div class="view-home">
    <header>
      <slider-home />
    </header>
    <!-- <header :style="`background-image: url(${bgUrl})`">
      <div class="container">
        <div class="row">
          <div v-if="course" class="col-lg-6 py-5 mt-5 order-lg-2">
            <h1 class="d-none text-uppercase mb-5">{{ course.title }}</h1>
            <div
              class="d-none course-description mb-5"
              v-html="course.description"
            />
            <div class="py-lg-5"></div>
            <div class="d-flex pt-lg-5 mt-lg-5">
              <router-link
                :to="{
                  name: 'course',
                  params: {
                    ...course
                  }
                }"
                class="btn btn-success btn-lg px-5 d-flex align-items-center"
              >
                COMEÇAR
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </header> -->

    <div class="container py-5">
      <action-dispatcher action="courses/getLastLessons">
        <h3 v-if="lastLessons.length" class="mb-4">
          Continue de onde parou...
        </h3>

        <div class="row">
          <div
            v-for="(lesson, i) in progressCourses"
            :key="'l' + i"
            class="col-xl-4 col-md-6 mb-4 d-flex"
          >
            <progress-course-card class="flex-fill" :lesson="lesson" />
          </div>
        </div>
      </action-dispatcher>

      <action-dispatcher action="courses/getCategories">
        <div class="row" v-for="(category, i) in categories" :key="'c' + i">
          <div class="col-12">
            <h3 class="mt-5 mb-4">{{ category.name }}</h3>
          </div>
          <div
            v-for="(course, i) in $user.courses.filter(
              c => c.category === category.id && !c.is_unlisted
            )"
            :key="i"
            class="col-lg-4 col-md-6 mb-4 d-flex"
          >
            <course-card class="flex-fill" :course="course" />
          </div>
        </div>
      </action-dispatcher>
    </div>

    <!-- <h1 class="text-center my-4">Outros Cursos</h1>

    <action-dispatcher action="courses/getAll">
      <div class="row">
        <template v-for="(course, i) in notMyCourses">
          <div
            v-if="!course.is_unlisted"
            class="col-lg-4 col-md-6 mb-4 d-flex"
            :key="i"
          >
            <course-card class="flex-fill" :course="course" external-link />
          </div>
        </template>
      </div>
    </action-dispatcher> -->
  </div>
</template>

<script>
import ProgressCourseCard from "@/components/home/ProgressCourseCard";
import CourseCard from "@/components/home/CourseCard";
import { mapState } from "vuex";
import get from "lodash/get";
import SliderHome from "@/components/home/SliderHome.vue";

export default {
  components: {
    CourseCard,
    ProgressCourseCard,
    SliderHome
  },
  computed: {
    ...mapState("courses", ["lastLessons", "courses", "categories"]),
    progressCourses() {
      return this.lastLessons.slice(0, 3);
    },
    notMyCourses() {
      return this.courses.filter(course => {
        return !this.$user.courses.find(myCourse => myCourse.id === course.id);
      });
    },
    course() {
      return get(this.$user, "courses", []).find(c => c.id === 2);
    },
    bgUrl() {
      return this.course?.cover || "";
    }
  }
};
</script>

<style lang="scss" scoped></style>
